module.exports = __webpack_public_path__ + "static/img/rightArrow.4f88ef17.png";